/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = ExternalOrDriveIn
 *
 * 1 = Internal
 *
 * 2 = UnderBonnet
 *
 * 3 = Underside
 *
 * 4 = BrakesAndHubs
 *
 * 5 = WheelsAndTyres
 */
export enum VHCRecordItemGroups {
  ExternalOrDriveIn = 0,
  Internal = 1,
  UnderBonnet = 2,
  Underside = 3,
  BrakesAndHubs = 4,
  WheelsAndTyres = 5,
}
